import { route }                                                                     from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes                                                                        from './routes'
import Supabase                                                                      from "src/composables/Supabase";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const { supabase, is_authenticated } = Supabase()
const check_for_auth_guard = async (to, from, next) => {

  const cookies = document.cookie.split(/\s*;\s*/).map(cookie => cookie.split('='))
  const accessTokenCookie = cookies.find(x => x[0] === 'my-access-token')
  const refreshTokenCookie = cookies.find(x => x[0] === 'my-refresh-token')

  if (!is_authenticated.value) {
    if (accessTokenCookie && refreshTokenCookie) {
      await supabase.auth.setSession({
        access_token: accessTokenCookie[1],
        refresh_token: refreshTokenCookie[1]
      })
    }
  }
  else {
    if (!accessTokenCookie || !refreshTokenCookie) {
      await supabase.auth.signOut()
    }
  }

  next()
}

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  Router.beforeEach(check_for_auth_guard)

  return Router
})
